import React from 'react';

import Dialog from '../../../../../../reusables/Dialog';
import DialogExtraCaption from '../../../../../../reusables/Dialog/extras/caption';

interface IProps {
  data: any;
  handlerClose: () => void;
  show: boolean;
}

const ErrorMessage = ({ data, handlerClose, show }: IProps) => (
  <Dialog
    handlerButtonA={() => handlerClose()}
    handlerClose={() => handlerClose()}
    maxWidth="360px"
    show={show}
    textButtonA="Entendido"
    zIndex={1000}
  >
    <DialogExtraCaption subtitle={data.description} title={data.title} />
  </Dialog>
);

export default ErrorMessage;
